import React, { Suspense } from 'react';

import LoadingSpinner from '../../Common/LoadingSpinner';
import ProtectedRoute from '../../Common/ProtectedRoute';
import MainLayout from '../../Layout/MainLayout';
import PublicApplicationForm from './PublicApplicationForm';

/**
 * /events/external-portal/apply/:token — the authenticated apply flow.
 * There is no public application form: anonymous visitors are redirected to /login by
 * ProtectedRoute (which preserves the target URL and returns here after sign-in). Logged-in
 * coordinators get MainLayout + portal behaviour (pre-fill, coordinator submit API).
 */
const EventExternalPortalApplyEntry = () => (
  <ProtectedRoute>
    <MainLayout>
      <Suspense fallback={<LoadingSpinner />}>
        <PublicApplicationForm coordinatorPortal />
      </Suspense>
    </MainLayout>
  </ProtectedRoute>
);

export default EventExternalPortalApplyEntry;
